import { FC, ReactElement, useState, useEffect } from 'react';
import { useDebouncedCallback } from 'dibs-react-hooks/exports/useDebouncedCallback';

export type QuickViewProviderChildrenProps = {
    openQuickView: (index: number) => void;
    closeQuickView: () => void;
    activeQuickView: number | null;
};

export const QuickViewProvider: FC<{
    children: ({ quickView }: { quickView: QuickViewProviderChildrenProps }) => ReactElement;
}> = ({ children }) => {
    const [activeQuickView, setActiveQuickView] = useState<number | null>(null);

    const openQuickView = (index: number): void => setActiveQuickView(index);
    const closeQuickView = (): void => setActiveQuickView(null);
    const [onResize] = useDebouncedCallback(closeQuickView);

    useEffect(() => {
        window.addEventListener('resize', onResize);

        return () => window.removeEventListener('resize', onResize);
    }, [onResize]);

    return children({
        quickView: {
            openQuickView,
            closeQuickView,
            activeQuickView,
        },
    });
};
